    export class MeterActivateModel {  id: number;
    grId: string;
    meterNum: string;
    turnOn: string;
    requestedDate: Date;
    email: string;
    aliases: any;
    prefix: any;
    cornerLotNo: any;
    adjoinStreetName: any;
    phoneNo: any;
    extension: any;
    recCreatedBy: any;
    builderId: any;
    closestMainInterSectStr: any;
    streNameThroughFare: any;
    comments: any;
    marketerId: any;
    recCreatedDTTM: string;
    }
